import QRCode from "qrcode";

/**
 * Generate QR code for given string, can be inputted into img tag, such as <img src={qrCode} alt="QR Code" />
 * @returns Base 64 QR code data URL
 */
async function qrCode(text: string): Promise<string> {
	const code = await QRCode.toDataURL(text, {
		color: {
			dark: "#FFFFFF",
			light: "#080F0F",
		},
	}).catch((err: unknown) => {
		console.error("Error generating QR code:", err);
		return "";
	});
	return code;
}

export default qrCode;
